export default __webpack_public_path__ + "static/media/notco-black.28eea428.png";